"use strict";

function verifyActiveElement() {
    var querystring = $("[data-querystring]").data("querystring");
    if (querystring != "" && querystring!= null) {
        var navItems = document.querySelectorAll(
            ".tabular-nav__items .tabular-nav__item[role='presentation']"
        );
        navItems.forEach(function (item) {
            var aId = item.querySelector(".top-level-category-names").id;
            var appearance = querystring.indexOf(aId);
            if (appearance != -1) {
                $("#" + aId).css("color", "#0857C3");
            }
        });
    }

}

function addCustomColorToBanner() {
    let topBannerHeader = $('.ryk-header__banner-wrapper,.header-banner');
    let backgroundColor = $('div[data-banner-header-background-color]').length > 0 ? $('div[data-banner-header-background-color]').data('banner-header-background-color') : null;
    let txtColor = $('div[data-banner-header-color-txt]').length > 0 ? $('div[data-banner-header-color-txt]').data('banner-header-color-txt') : null;
    if (backgroundColor || txtColor) {
        topBannerHeader.css('cssText','background-color: ' + backgroundColor + ' !important;' + 'color: ' + txtColor +' !important;');
    }
}

$(".tabular-nav__item").hover(
    function () {
        $(".tabular-nav__mega-menu:not(:animated)", this).fadeIn(200);
        $(".top-level-category-names", this).css("color", "#0857C3");
        verifyActiveElement();
    },
    function () {
        $(".tabular-nav__mega-menu", this).fadeOut(200);
        $(".top-level-category-names", this).css("color", "black");
        verifyActiveElement();
    }
);

$(".searchBar-button").click(function () {
    $("#search-bar-ctn").fadeToggle(185);
    $(".ryk-searchbar").fadeToggle(185);
    $("#search-bar-ctn").toggleClass("d-none d-flex");

    $(".searchBar-button #search-icon").toggle();
    $(".searchBar-button #cross-icon").toggleClass("d-none d-flex");
});

$(".searchbar-close").click(function () {
    $("#search-bar-ctn").fadeOut(150);
    $(".ryk-searchbar").fadeOut(150);
    $("#search-bar-ctn").removeClass("d-flex").addClass("d-none");

    $(".searchBar-button #search-icon").toggle();
    $(".searchBar-button #cross-icon").toggleClass("d-flex d-none");
});

$(".mobile-nav-button").click(function () {
    $("#mobileNavigationContainer").show(450);
});
$(".close-mobile-nav").click(function () {
    $("#mobileNavigationContainer").hide(450);
});
$(".user-dropdown-toggle").click(function () {
    $(".user-popover").slideToggle(185);
});

$('.btnCollapsed').click(function () {
    $(this).toggleClass('rotate-icon-down');
});

verifyActiveElement();
addCustomColorToBanner();
